import React from "react";
import { TableCell } from "../../models/table";
import styles from "./Table.module.scss";

interface Props {
  cells: TableCell[];
  className?: string;
}

const TableRow = ({ className = "", cells }: Props) => (
  <div className={`${styles.tableRow} ${className}`.trim()} style={{ gridTemplateColumns: `repeat(${cells.length}, 1fr)` }}>
    {cells.map((cell, i) => (
      <div className={styles.tableRowCell} key={i}>
        {cell}
      </div>
    ))}
  </div>
);

export default TableRow;
